import React from "react";
import { Box, Stack, Card, CardContent, Typography } from "@mui/material";
import AppBreadcrumbs from "../../components/AppBreadcrumbs";
import { useNavigate } from "react-router-dom";

const statusButtons = [
  { label: "เปิดBatchระบุชื่อ", color: "#1c1e2a", textColor: "white", url: "/buy/customers" },
  { label: "Batchรอจ่าย", color: "#42a5f5", url: "/buy/ticket?status=waiting" },
  {
    label: "Batchจ่ายแล้ว",
    color: "#b2f2bb",
    url: "/buy/ticket?status=payed",
  },
  {
    label: "Batchที่ถูกยกเลิก",
    color: "#f8d7da",
    url: "/buy/ticket?status=cancel",
  },
];

export default function CameraPanel() {
  const navigate = useNavigate();

  const handleClick = (url) => {
    navigate(url);
  };

  return (
    <>
      <Box p={2}>
        <AppBreadcrumbs />
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100vh"
          boxSizing="border-box"
        >
          <Stack
            direction="row"
            spacing={2}
            sx={{
              width: "100%",
              justifyContent: "center",
              overflowX: "auto", // ทำให้เลื่อนได้แนวนอนถ้าเล็ก
              padding: 1,
            }}
          >
            {statusButtons.map((item) => (
              <Card
                key={item.label}
                onClick={() => handleClick(item.url)}
                sx={{
                  minWidth: 200,
                  height: 120,
                  backgroundColor: item.color,
                  color: item.textColor,
                  borderRadius: 3,
                  cursor: "pointer",
                  boxShadow: 4,
                  transition: "transform 0.2s",
                  "&:hover": {
                    transform: "scale(1.05)",
                  },
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <CardContent>
                  <Typography
                    variant="h6"
                    align="center"
                    fontWeight="bold"
                    sx={{ whiteSpace: "nowrap" }}
                  >
                    {item.label}
                  </Typography>
                </CardContent>
              </Card>
            ))}
          </Stack>
        </Box>
      </Box>
    </>
  );
}

// import React, { useEffect, useRef, useState } from "react";
// import { Box, Button, Typography, Stack, styled } from "@mui/material";
// import AppBreadcrumbs from "../../components/AppBreadcrumbs";
// import { useNavigate } from "react-router-dom";

// const statusButtons = [
//   // { label: 'เปิดBatchไม่ระบุชื่อ', color: '#4caf50', url: '/buy/customers' },
//   { label: 'เปิดBatchระบุชื่อ', color: '#1c1e2a', url: '/buy/customers' },
//   { label: 'Batchรอจ่าย', color: '#42a5f5', url: '/buy/ticket' },
//   { label: 'Batchจ่ายแล้ว', color: '#b2f2bb', url: '/buy/customers' },
//   { label: 'Batchที่ถูกยกเลิก', color: '#f8d7da', url: '/buy/customers' },
//   // { label: 'ราคารับซื้อ', color: '#cfd8dc', url: '/buy/customers' }
// ];

// export default function CameraPanel() {
//   const videoRef = useRef(null);
//   const navigate = useNavigate();

//   useEffect(() => {
//     async function enableCamera() {
//       try {
//         const stream = await navigator.mediaDevices.getUserMedia({
//           video: true,
//         });
//         if (videoRef.current) {
//           videoRef.current.srcObject = stream;
//         }
//       } catch (err) {
//         console.error("ไม่สามารถเข้าถึงกล้องได้:", err);
//       }
//     }

//     enableCamera();
//   }, []);
//   const handleClick = (index) => {
//    const path = statusButtons[index].url
//     // setSelectedIndex(index)
//     navigate(path);
//   };

//   return (
//     <>
//     <AppBreadcrumbs />

//     <Box
//       display="flex"
//       justifyContent="flex-end"
//       height="100vh"
//       width="100vw"
//       p={2}
//       boxSizing="border-box"
//     >
//       <Box
//         sx={{
//           flex: "0 0 78%",
//           borderRadius: 2,
//           overflow: "hidden",
//           backgroundColor: "#000",
//           mr: 2,
//         }}
//       >
//         <video
//           ref={videoRef}
//           autoPlay
//           playsInline
//           muted
//           style={{ width: "100%", height: "100%", objectFit: "cover" }}
//         />
//       </Box>

//       {/* ฝั่งปุ่ม 20% */}
//       <Stack
//         spacing={2}
//         sx={{
//           flex: "0 0 20%",
//           alignItems: "stretch",
//           justifyContent: "center",
//         }}
//       >
//         {statusButtons.map((item, index) => {
//           // const isSelected = index === selectedIndex;
//           return (
//             <Button
//               key={item.label}
//               onClick={() => handleClick(index)}
//               sx={{
//                 backgroundColor: item.color,
//                 color: index === 1 ? "white" : "black",
//                 // justifyContent: "flex-end", // ชิดขวา
//                 paddingRight: 2,
//                 borderRadius: 2,
//                 // border: isSelected ? "4px solid red" : "none",
//                 fontWeight: "bold",
//                 fontSize: "1rem",
//                 // boxShadow: isSelected ? 4 : 1,
//                 // "&:hover": {
//                 //   backgroundColor: item.color,
//                 // },
//                 height: 100,
//                 width: "100%",
//               }}
//             >
//               {item.label}
//             </Button>
//           );
//         })}
//       </Stack>
//     </Box>
//     </>
//   );
// }
